function Content ({ id, type, attributes }) {
  this.id = id
  this.type = type
  this.attributes = attributes
}

export {
  Content
}
